import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { SalesforceService } from '../../services/salesforce.service'

/**
 * Interfaz para la llamada a un método con parámetros
 */
interface MethodCallWithParams {
    /** Nombre del método a ejecutar */
    methodName: string;
    /** Parámetros para el método */
    params?: any[];
}

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ButtonComponent
    ]
})
export class ConfirmModalComponent implements OnInit{
    @Input() isOpen = false
    @Input() title = ''
    @Input() message = ''
    @Input() messageTwo = ''
    @Input() itemId: number
    @Input() twoSteps: boolean
    @Input() confirmText = 'common.buttons.confirm'
    @Input() cancelText = 'common.buttons.cancel'
    @Input() hideFooter = false
    @Input() buttonsInRow = false
    @Input() maxWidth = ''
    @Input() confirmButtonStyle: 'primary' | 'secondary' | 'ghost' = 'primary'
    @Input() cancelButtonStyle: 'primary' | 'secondary' | 'ghost' = 'ghost'
    @Input() confirmMethod?: string
    @Input() cancelMethod?: string
    @Input() confirmParams?: any[]
    @Input() cancelParams?: any[]
    @Input() gtmLabelConfirm?: string
    @Input() gtmLabelCancel?: string
    @Output() onConfirm = new EventEmitter<void>()
    @Output() onCancel = new EventEmitter<void>()
    @Output() onClose = new EventEmitter<void>()
    @Output() methodCall = new EventEmitter<MethodCallWithParams>()

    inCanvas = false;

    constructor(private salesforce: SalesforceService) {
    }

    ngOnInit() {
        this.inCanvas = this.salesforce.isCanvas()
    }

    currentStep = 1

    confirm() {
        this.currentStep = 1
        if (this.confirmMethod) {
            this.methodCall.emit({
                methodName: this.confirmMethod,
                params: this.confirmParams
            })
        } else {
            this.onConfirm.emit()
        }
    }

    cancel() {
        this.currentStep = 1
        if (this.cancelMethod) {
            this.methodCall.emit({
                methodName: this.cancelMethod,
                params: this.cancelParams
            })
        } else {
            this.onCancel.emit()
        }
    }

    close(){
        this.onClose.emit()
    }
}
